<section class="current-order-ready-section">
  <div class="order-header">
    <div class="header-title">
      Order ready
    </div>
  </div>
  <div class="order-container" [ngClass]="{'order-big-container': currentOrders.prepared.length > 12}">
    <div class="order-card" *ngFor="let order of currentOrders.prepared">
      <div class="status-color"
           [ngClass]="{
           'green': order.type === itemType.take_out,
           'yellow': order.type === itemType.dine_in,
           'purple': order.type === itemType.delivery && isSpecial
           }">
      </div>
      <div class="card-container">
        <div *ngIf="isSpecial">
          {{order.source}}
        </div>
        <div class="name-container">
          <div class="name">
            {{order.customerName}}
          </div>
          <div class="order-number">
            {{order.number}}
          </div>
        </div>
        <div class="icon-container">
          <div class="icon-content">
            <ng-container *ngIf="isGroup">
              {{order?.locationName}}
            </ng-container>
          </div>
          <div class="order-time">
            {{order.orderDate}} {{order.pickup}}
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
